import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import "./CommonTable.css";

interface Props {
  rows: any;
  columns: any;
  checkboxSelection?: boolean;
  onRowClicked?: any;
  getRowId?: any;
  rowHeight?: any;
  onRowSelectionModelChange?: (e: any) => void;
}

const CommonTable = ({
  rows,
  columns,
  checkboxSelection = false,
  getRowId = (e: any) => {
    return e.id;
  },
  rowHeight = 50,
  onRowClicked = (e: any) => {},
  onRowSelectionModelChange = (e: any) => {},
}: Props) => {
  // console.log('rows', rows)
  // console.log('columns', columns)
  return (
    <div>
      <DataGrid
        getRowId={getRowId}
        rows={rows}
        autoHeight
        rowHeight={rowHeight}
        columns={columns}
        slots={{
          pagination: null,
        }}
        disableRowSelectionOnClick
        checkboxSelection={checkboxSelection}
        onRowSelectionModelChange={onRowSelectionModelChange}
        onRowClick={onRowClicked}
      ></DataGrid>
    </div>
  );
};

export default CommonTable;
